"use strict";
(() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // lib/dealer-stage/mapping.js
  var require_mapping = __commonJS({
    "lib/dealer-stage/mapping.js"(exports, module) {
      "use strict";
      function validateTimeline(timeline) {
        if (!timeline || typeof timeline !== "object") return ["timeline must be an object"];
        var errors = [];
        if (timeline.schemaVersion !== 1) errors.push("schemaVersion must be 1");
        if (!(typeof timeline.fps === "number" && timeline.fps > 0)) errors.push("fps must be a positive number");
        var states = Array.isArray(timeline.states) ? timeline.states : [];
        var segments = Array.isArray(timeline.segments) ? timeline.segments : [];
        if (states.length === 0) errors.push("states must be non-empty");
        var ids = states.map(function(s) {
          return s && s.id;
        });
        if (new Set(ids).size !== ids.length) errors.push("state ids must be unique");
        if (ids.indexOf(timeline.initialState) === -1) errors.push("initialState must name a state");
        states.forEach(function(s, i) {
          if (!(typeof s.hold === "number" && s.hold >= 0)) errors.push("state " + s.id + " hold must be >= 0");
          if (i > 0 && !(s.hold > states[i - 1].hold)) errors.push("state holds must strictly increase: " + s.id);
        });
        if (segments.length !== Math.max(0, states.length - 1)) errors.push("segments must be states.length - 1");
        segments.forEach(function(seg, i) {
          if (seg.from !== ids[i] || seg.to !== ids[i + 1]) {
            errors.push("segment " + seg.id + " must go " + ids[i] + " -> " + ids[i + 1]);
          }
          if (!(seg.start <= seg.hold && seg.hold < seg.endExclusive)) {
            errors.push("segment " + seg.id + " must satisfy start <= hold < endExclusive");
          }
          if (i > 0 && seg.start !== segments[i - 1].endExclusive) {
            errors.push("segment " + seg.id + " must start where the previous segment ends");
          }
        });
        return errors;
      }
      function frameCount(timeline) {
        var last = timeline.segments[timeline.segments.length - 1];
        return Math.round(last.endExclusive * timeline.fps);
      }
      function chooseSource(viewportWidth) {
        return viewportWidth < 768 ? "mobile" : "desktop";
      }
      module.exports = {
        validateTimeline,
        frameCount,
        chooseSource
      };
    }
  });

  // lib/dealer-stage/beats.js
  var require_beats = __commonJS({
    "lib/dealer-stage/beats.js"(exports, module) {
      "use strict";
      var ANCHORS = { tl: "0 0", tc: "-50% 0", tr: "-100% 0", ml: "0 -50%", mc: "-50% -50%", mr: "-100% -50%", bl: "0 -100%", bc: "-50% -100%", br: "-100% -100%" };
      var KINDS = ["kicker", "title", "line", "callout", "ui"];
      var DEVICES = ["desktop", "mobile"];
      var CALLOUT_STAGGER = 0.15;
      var LIFT = 16;
      var DROP = 8;
      function isPct(n) {
        return typeof n === "number" && n >= 0 && n <= 100;
      }
      function validate(data, timeline) {
        if (!data || typeof data !== "object") return ["beats must be an object"];
        var errors = [];
        if (data.schemaVersion !== 1) errors.push("schemaVersion must be 1");
        DEVICES.forEach(function(d) {
          var p = data.picture && data.picture[d];
          if (!(Array.isArray(p) && p.length === 2 && p[0] > 0 && p[1] > 0)) errors.push("picture." + d + " must be [w, h]");
          var f = data.fallback && data.fallback[d];
          if (!(f && isPct(f.x) && isPct(f.y) && ANCHORS[f.anchor] && f.step > 0)) errors.push("fallback." + d + " must give x, y, anchor, step");
        });
        var stateIds = timeline && Array.isArray(timeline.states) ? timeline.states.map(function(s) {
          return s.id;
        }) : null;
        function checkTimelineState(label, field, id) {
          if (stateIds && stateIds.indexOf(id) === -1) errors.push(label + " " + field + " " + id + " is not in the timeline");
        }
        var list = Array.isArray(data.beats) ? data.beats : [];
        if (!list.length) errors.push("beats must be non-empty");
        var seen = {};
        list.forEach(function(b, i) {
          var label = "beat " + (b && b.id ? b.id : "#" + i);
          if (!b || typeof b.id !== "string" || !b.id) {
            errors.push(label + " needs an id");
            return;
          }
          if (seen[b.id]) errors.push("duplicate id " + b.id);
          seen[b.id] = true;
          if (!/^K\d$/.test(String(b.state))) errors.push(label + " state must be K<n>");
          else checkTimelineState(label, "state", b.state);
          if (KINDS.indexOf(b.kind) === -1) errors.push(label + " kind must be one of " + KINDS.join("|"));
          if (b.until !== void 0) {
            if (!/^K\d$/.test(String(b.until))) errors.push(label + " until must be K<n>");
            else checkTimelineState(label, "until", b.until);
          }
          DEVICES.forEach(function(d) {
            var box = b[d];
            if (!box) {
              errors.push(label + " is missing " + d);
              return;
            }
            if (!isPct(box.x)) errors.push(label + " " + d + " x must be 0..100");
            if (!isPct(box.y)) errors.push(label + " " + d + " y must be 0..100");
            if (!ANCHORS[box.anchor]) errors.push(label + " " + d + " anchor must be one of " + Object.keys(ANCHORS).join("|"));
            if (box.w !== void 0 && !(box.w > 0 && box.w <= 100)) errors.push(label + " " + d + " w must be 0..100");
            if (b.kind === "callout" && !(box.target && isPct(box.target.x) && isPct(box.target.y))) errors.push(label + " callout " + d + " needs a target");
            if (box.until !== void 0) {
              if (!/^K\d$/.test(String(box.until))) errors.push(label + " " + d + " until must be K<n>");
              else checkTimelineState(label, d + ".until", box.until);
            }
          });
        });
        return errors;
      }
      function stateIndex(timeline, id) {
        for (var i = 0; i < timeline.states.length; i += 1) if (timeline.states[i].id === id) return i;
        return -1;
      }
      function windows(data, timeline, device) {
        var dev = device || "desktop";
        var defaults = data.defaults || {};
        var lead = defaults.lead === void 0 ? 0.7 : defaults.lead;
        var span = defaults.span === void 0 ? 0.4 : defaults.span;
        var stagger = defaults.stagger === void 0 ? 0.12 : defaults.stagger;
        var counts = {};
        data.beats.forEach(function(b) {
          counts[b.state] = (counts[b.state] || 0) + 1;
        });
        var ordinal = {};
        var out = {};
        data.beats.forEach(function(b) {
          var k = ordinal[b.state] || 0;
          ordinal[b.state] = k + 1;
          var si = stateIndex(timeline, b.state);
          var hold = timeline.states[si].hold;
          var visible = hold - (counts[b.state] - 1 - k) * stagger;
          var until = b[dev] && b[dev].until || b.until || b.state;
          var ui = stateIndex(timeline, until);
          var next = timeline.segments[ui];
          var hide = next ? next.start : null;
          out[b.id] = { start: visible - lead, visible, hide, end: hide === null ? null : hide + span };
        });
        return out;
      }
      function coverBox(picture, vw, vh) {
        var w = vw;
        var h = vw * picture[1] / picture[0];
        if (h < vh) {
          h = vh;
          w = vh * picture[0] / picture[1];
        }
        return { x: Math.round((vw - w) / 2), y: Math.round((vh - h) / 2), w: Math.round(w), h: Math.round(h) };
      }
      function place(point, box) {
        return { x: Math.round(box.x + point.x / 100 * box.w), y: Math.round(box.y + point.y / 100 * box.h) };
      }
      function anchorOffset(anchor) {
        var parts = ANCHORS[anchor].split(" ");
        return { x: -parseFloat(parts[0]) / 100, y: -parseFloat(parts[1]) / 100 };
      }
      var EDGE = 16;
      function clampToViewport(at, width, anchor, viewport) {
        var frac = anchorOffset(anchor);
        var w = width ? Math.min(width, viewport.w - 2 * EDGE) : 0;
        var left = at.x - frac.x * w;
        left = Math.min(Math.max(EDGE, left), Math.max(EDGE, viewport.w - w - EDGE));
        return {
          x: Math.round(left + frac.x * w),
          y: Math.min(Math.max(EDGE, at.y), viewport.h - EDGE),
          width: w || null
        };
      }
      function layout(beat, device, box, fallbackIndex, fallback, viewport) {
        var spec = beat[device];
        var fb = fallback || { desktop: { x: 5, y: 52, anchor: "tl", w: 30, step: 6 }, mobile: { x: 6, y: 30, anchor: "tl", w: 84, step: 5 } };
        if (!spec) {
          var f = fb[device];
          spec = { x: f.x, y: f.y + f.step * (fallbackIndex || 0), anchor: f.anchor, w: f.w };
        }
        var at = place(spec, box);
        var width = spec.w ? Math.round(spec.w / 100 * box.w) : null;
        var connector = null;
        if (beat.kind === "callout" && spec.target) {
          var target = place(spec.target, box);
          var dx = at.x - target.x;
          var dy = at.y - target.y;
          connector = { dx, dy, length: Math.round(Math.sqrt(dx * dx + dy * dy)), angle: Math.round(Math.atan2(dy, dx) * 180 / Math.PI * 100) / 100 };
          at = target;
        } else if (viewport) {
          var fitted = clampToViewport(at, width, spec.anchor, viewport);
          at = { x: fitted.x, y: fitted.y };
          width = fitted.width;
        }
        return { left: at.x, top: at.y, width, translate: ANCHORS[spec.anchor], connector };
      }
      function enterFrames(kind) {
        if (kind === "dot") return [{ opacity: 0, visibility: "hidden", transform: "scale(0)" }, { opacity: 1, visibility: "visible", transform: "scale(1)" }];
        if (kind === "line") return [{ opacity: 0, visibility: "hidden", transform: "scaleX(0)" }, { opacity: 1, visibility: "visible", transform: "scaleX(1)" }];
        return [{ opacity: 0, visibility: "hidden", transform: "translateY(" + LIFT + "px)" }, { opacity: 1, visibility: "visible", transform: "translateY(0)" }];
      }
      function exitFrame(kind) {
        if (kind === "dot") return { opacity: 0, visibility: "hidden", transform: "scale(0)" };
        if (kind === "line") return { opacity: 0, visibility: "hidden", transform: "scaleX(1)" };
        return { opacity: 0, visibility: "hidden", transform: "translateY(" + -DROP + "px)" };
      }
      function clampOffset(n) {
        return Math.min(1, Math.max(0, n));
      }
      function partAnimation(part, kind, start, visible, hide, end) {
        var enter = enterFrames(kind);
        var keyframes;
        var total;
        if (hide === null) {
          total = Math.max(0.05, visible - start);
          keyframes = [Object.assign({ offset: 0 }, enter[0]), Object.assign({ offset: 1 }, enter[1])];
        } else {
          total = Math.max(0.05, end - start);
          keyframes = [
            Object.assign({ offset: 0 }, enter[0]),
            Object.assign({ offset: clampOffset((visible - start) / total) }, enter[1]),
            Object.assign({ offset: clampOffset((hide - start) / total) }, enter[1]),
            Object.assign({ offset: 1 }, exitFrame(kind))
          ];
        }
        return { part, start, total, keyframes };
      }
      function animations(beat, win) {
        if (beat.kind !== "callout") {
          return [partAnimation("root", "text", win.start, win.visible, win.hide, win.end)];
        }
        return ["dot", "line", "label"].map(function(part, i) {
          var shift = (2 - i) * CALLOUT_STAGGER;
          return partAnimation(part, part === "label" ? "text" : part, win.start - shift, win.visible - shift, win.hide, win.end);
        });
      }
      function progress(t, start, total) {
        return Math.round(Math.min(Math.max(0, (t - start) * 1e3), total * 1e3));
      }
      module.exports = {
        ANCHORS,
        DEVICES,
        validate,
        windows,
        coverBox,
        place,
        layout,
        animations,
        progress
      };
    }
  });

  // lib/dealer-stage/scrub.js
  var require_scrub = __commonJS({
    "lib/dealer-stage/scrub.js"(exports, module) {
      "use strict";
      function curve(timeline, viewportHeight, options) {
        var opts = options || {};
        var travel = opts.travel === void 0 ? viewportHeight : opts.travel;
        var dwell = opts.dwell === void 0 ? Math.round(viewportHeight * 0.4) : opts.dwell;
        var spans = [];
        var y = 0;
        timeline.states.forEach(function(state, i) {
          spans.push({ y0: y, y1: y + dwell, t0: state.hold, t1: state.hold });
          y += dwell;
          var next = timeline.states[i + 1];
          if (next) {
            spans.push({ y0: y, y1: y + travel, t0: state.hold, t1: next.hold });
            y += travel;
          }
        });
        return { length: y, spans };
      }
      function timeAt(c, y) {
        if (y <= 0) return c.spans[0].t0;
        var last = c.spans[c.spans.length - 1];
        if (y >= c.length) return last.t1;
        for (var i = 0; i < c.spans.length; i += 1) {
          var s = c.spans[i];
          if (y < s.y1) {
            var span = s.y1 - s.y0;
            return span > 0 ? s.t0 + (s.t1 - s.t0) * ((y - s.y0) / span) : s.t0;
          }
        }
        return last.t1;
      }
      function frameAt(t, fps, count) {
        return Math.min(count - 1, Math.max(0, Math.round(t * fps)));
      }
      function progressiveOrder(count) {
        var seen = {};
        var order = [];
        [8, 4, 2, 1].forEach(function(step) {
          for (var i = 0; i < count; i += step) {
            if (!seen[i]) {
              seen[i] = true;
              order.push(i);
            }
          }
        });
        return order;
      }
      function holdTargets(c) {
        return c.spans.filter(function(s) {
          return s.t0 === s.t1;
        }).map(function(s) {
          return Math.round((s.y0 + s.y1) / 2);
        });
      }
      function nextHold(targets, y, direction) {
        if (direction > 0) {
          for (var i = 0; i < targets.length; i += 1) if (targets[i] > y + 1) return i === 0 && targets.length > 1 ? 1 : i;
          return -1;
        }
        for (var j = targets.length - 1; j >= 0; j -= 1) if (targets[j] < y - 1) return j;
        return -1;
      }
      function stepDurationMs(timeline, from, to, rate) {
        var r = rate || 1.4;
        var distance = Math.abs(timeline.states[to].hold - timeline.states[from].hold);
        return Math.max(600, Math.round(distance / r * 1e3));
      }
      module.exports = {
        curve,
        timeAt,
        frameAt,
        progressiveOrder,
        holdTargets,
        nextHold,
        stepDurationMs
      };
    }
  });

  // lib/dealer-stage/track.js
  var require_track = __commonJS({
    "lib/dealer-stage/track.js"(exports, module) {
      "use strict";
      var beats2 = require_beats();
      function textAlignFor(translate) {
        if (translate.indexOf("-50%") === 0) return "center";
        if (translate.indexOf("-100%") === 0) return "right";
        return "";
      }
      function setLayout(el, beat, lay) {
        el.style.left = lay.left + "px";
        el.style.top = lay.top + "px";
        el.style.width = lay.width ? lay.width + "px" : "";
        el.style.translate = lay.connector ? "0 0" : lay.translate;
        el.style.textAlign = lay.connector || beat.kind === "ui" ? "" : textAlignFor(lay.translate);
        if (lay.connector) {
          el.style.setProperty("--label-dx", lay.connector.dx + "px");
          el.style.setProperty("--label-dy", lay.connector.dy + "px");
          el.style.setProperty("--label-translate", lay.translate);
          el.style.setProperty("--line-length", lay.connector.length + "px");
          el.style.setProperty("--line-angle", lay.connector.angle + "deg");
        }
      }
      function partElement(el, part) {
        if (part === "root") return el;
        return el.querySelector(".tt-beat-" + part);
      }
      function createTrack(options) {
        var data = options.data;
        var timeline = options.timeline;
        var device = options.device;
        var picture = data.picture[device];
        var root = options.root || document;
        var size = options.size;
        var windows = beats2.windows(data, timeline, device);
        var byId = {};
        data.beats.forEach(function(b) {
          byId[b.id] = b;
        });
        var items = [];
        var unknown = 0;
        Array.prototype.forEach.call(root.querySelectorAll("[data-beat]"), function(el) {
          var id = el.getAttribute("data-beat");
          var beat = byId[id];
          var fallbackIndex = 0;
          if (!beat) {
            beat = { id, state: "K3", kind: el.classList.contains("tt-beat--callout") ? "callout" : "line" };
            fallbackIndex = unknown++;
            windows[id] = beats2.windows({ defaults: data.defaults, beats: [beat] }, timeline, device)[id];
          }
          var parts = beats2.animations(beat, windows[id]).map(function(a) {
            var target = partElement(el, a.part);
            if (!target) return null;
            var anim = target.animate(a.keyframes, { duration: a.total * 1e3, fill: "both" });
            anim.pause();
            return { anim, start: a.start, total: a.total };
          }).filter(Boolean);
          items.push({ el, beat, fallbackIndex, parts });
        });
        function relayout() {
          var viewport = size ? size() : { w: window.innerWidth, h: window.innerHeight };
          var box = beats2.coverBox(picture, viewport.w, viewport.h);
          items.forEach(function(item) {
            setLayout(item.el, item.beat, beats2.layout(item.beat, device, box, item.fallbackIndex, data.fallback, viewport));
          });
        }
        function sync(t) {
          items.forEach(function(item) {
            item.parts.forEach(function(p) {
              p.anim.currentTime = beats2.progress(t, p.start, p.total);
            });
          });
        }
        function destroy() {
          items.forEach(function(item) {
            item.parts.forEach(function(p) {
              p.anim.cancel();
            });
            var style = item.el.style;
            style.removeProperty("left");
            style.removeProperty("top");
            style.removeProperty("width");
            style.removeProperty("translate");
            style.removeProperty("text-align");
            style.removeProperty("--label-dx");
            style.removeProperty("--label-dy");
            style.removeProperty("--label-translate");
            style.removeProperty("--line-length");
            style.removeProperty("--line-angle");
          });
          items = [];
        }
        relayout();
        return { sync, relayout, destroy };
      }
      module.exports = { createTrack };
    }
  });

  // lib/dealer-stage/frames.js
  var require_frames = __commonJS({
    "lib/dealer-stage/frames.js"(exports, module) {
      "use strict";
      var scrub2 = require_scrub();
      var IN_FLIGHT = 4;
      var DECODE_AHEAD = 3;
      function createFrameRenderer(options) {
        var canvas = options.canvas;
        var ctx = canvas.getContext("2d");
        var count = options.count;
        var fps = options.fps;
        var frames2 = new Array(count);
        var loaded = [];
        var queue = scrub2.progressiveOrder(count);
        var active = 0;
        var destroyed = false;
        var current = -1;
        var width = 0;
        var height = 0;
        var dpr = Math.min(2, window.devicePixelRatio || 1);
        var poster = options.poster || null;
        function insertLoaded(index) {
          var lo = 0;
          var hi = loaded.length;
          while (lo < hi) {
            var mid = lo + hi >> 1;
            if (loaded[mid] < index) lo = mid + 1;
            else hi = mid;
          }
          loaded.splice(lo, 0, index);
        }
        function store(index, image) {
          if (destroyed) return;
          frames2[index] = image;
          insertLoaded(index);
          if (current === -1) draw(index);
          else if (nearestLoaded(current) === index) draw(current);
        }
        function pump() {
          while (active < IN_FLIGHT && queue.length && !destroyed) {
            var index = queue.shift();
            if (frames2[index]) continue;
            active += 1;
            load(index);
          }
        }
        function load(index) {
          var img = new Image();
          img.decoding = "async";
          img.onload = function() {
            active -= 1;
            store(index, img);
            pump();
          };
          img.onerror = function() {
            active -= 1;
            pump();
          };
          img.fetchPriority = "low";
          img.src = options.urlFor(index);
        }
        function nearestLoaded(index) {
          if (!loaded.length) return -1;
          var lo = 0;
          var hi = loaded.length - 1;
          while (lo < hi) {
            var mid = lo + hi >> 1;
            if (loaded[mid] < index) lo = mid + 1;
            else hi = mid;
          }
          var a = loaded[lo];
          var b = lo > 0 ? loaded[lo - 1] : a;
          return Math.abs(a - index) <= Math.abs(b - index) ? a : b;
        }
        function decodeAhead(index) {
          for (var k = 1; k <= DECODE_AHEAD; k += 1) {
            [index + k, index - k].forEach(function(i) {
              var img = frames2[i];
              if (img && img.decode && !img.__decoded) {
                img.__decoded = true;
                img.decode().catch(function() {
                  img.__decoded = false;
                });
              }
            });
          }
        }
        function cover(iw, ih) {
          var scale = Math.max(width / iw, height / ih);
          var w = iw * scale;
          var h = ih * scale;
          return { x: (width - w) / 2, y: (height - h) / 2, w, h };
        }
        function draw(index) {
          if (!width || !height) return;
          var pick = nearestLoaded(index);
          var image = pick === -1 ? poster : frames2[pick];
          if (!image) return;
          var iw = image.naturalWidth || image.width;
          var ih = image.naturalHeight || image.height;
          if (!iw || !ih) return;
          var box = cover(iw, ih);
          ctx.drawImage(image, box.x, box.y, box.w, box.h);
          if (pick !== -1) decodeAhead(pick);
        }
        function resize() {
          width = Math.round(canvas.clientWidth * dpr);
          height = Math.round(canvas.clientHeight * dpr);
          canvas.width = width;
          canvas.height = height;
          draw(current === -1 ? 0 : current);
        }
        function seek(t) {
          var index = scrub2.frameAt(t, fps, count);
          if (index === current) return;
          current = index;
          draw(index);
        }
        resize();
        if (window.requestIdleCallback) window.requestIdleCallback(pump);
        else setTimeout(pump, 300);
        return {
          seek,
          resize,
          destroy: function() {
            destroyed = true;
            frames2 = [];
            loaded = [];
            queue = [];
          }
        };
      }
      module.exports = { createFrameRenderer };
    }
  });

  // lib/dealer-stage/video-scrub.js
  var require_video_scrub = __commonJS({
    "lib/dealer-stage/video-scrub.js"(exports, module) {
      "use strict";
      var STEP = 1 / 48;
      function createVideoScrubber(options) {
        var video = options.video;
        var wanted = null;
        var busy = false;
        var guard = 0;
        function apply() {
          if (video.readyState === 0) return;
          if (busy || wanted === null) return;
          if (Math.abs(video.currentTime - wanted) < STEP) {
            wanted = null;
            return;
          }
          busy = true;
          video.currentTime = wanted;
          wanted = null;
          clearTimeout(guard);
          guard = setTimeout(onSeeked, 300);
        }
        function onSeeked() {
          clearTimeout(guard);
          busy = false;
          apply();
        }
        video.addEventListener("seeked", onSeeked);
        video.addEventListener("loadedmetadata", onSeeked);
        return {
          seek: function(t) {
            wanted = t;
            apply();
          },
          destroy: function() {
            clearTimeout(guard);
            video.removeEventListener("seeked", onSeeked);
            video.removeEventListener("loadedmetadata", onSeeked);
          }
        };
      }
      module.exports = { createVideoScrubber };
    }
  });

  // lib/dealer-stage/wheel-step.js
  var require_wheel_step = __commonJS({
    "lib/dealer-stage/wheel-step.js"(exports, module) {
      "use strict";
      var scrub2 = require_scrub();
      var THRESHOLD = 8;
      var TAIL = 0.85;
      function easeOut(t) {
        t = Math.min(1, Math.max(0, t));
        return 1 - (1 - t) * (1 - t);
      }
      function wheelPixels(event) {
        if (event.deltaMode === 1) return event.deltaY * 16;
        if (event.deltaMode === 2) return event.deltaY * window.innerHeight;
        return event.deltaY;
      }
      var token = 0;
      function glide(y, ms, onProgress, onDone) {
        var mine = ++token;
        var from = window.scrollY;
        var start = 0;
        function frame(now) {
          if (mine !== token) return;
          if (!start) start = now;
          var p = Math.min(1, (now - start) / ms);
          if (onProgress) onProgress(p);
          window.scrollTo({ top: Math.round(from + (y - from) * easeOut(p)), left: 0, behavior: "instant" });
          if (p < 1) {
            window.requestAnimationFrame(frame);
            return;
          }
          if (onDone) onDone();
        }
        window.requestAnimationFrame(frame);
      }
      function createWheelStepper(options) {
        var timeline = options.timeline;
        var tweening = false;
        var progress = 0;
        var pending = 0;
        var destroyed = false;
        function inside() {
          var y = window.scrollY - options.worldTop();
          return y > -window.innerHeight && y < options.curve().length + 1;
        }
        function targetFor(direction) {
          var c = options.curve();
          var targets = scrub2.holdTargets(c);
          var offset = window.scrollY - options.worldTop();
          var index = scrub2.nextHold(targets, offset, direction);
          if (index === -1) {
            return { y: direction > 0 ? options.worldTop() + c.length + window.innerHeight : 0, ms: 900 };
          }
          var nearest = 0;
          for (var i = 0; i < targets.length; i += 1) if (Math.abs(targets[i] - offset) < Math.abs(targets[nearest] - offset)) nearest = i;
          var ms = scrub2.stepDurationMs(timeline, nearest, index);
          var full = Math.abs(targets[index] - targets[nearest]) || 1;
          ms = Math.max(600, Math.round(ms * Math.min(1, Math.abs(targets[index] - offset) / full)));
          return { y: options.worldTop() + targets[index], ms };
        }
        function glideTo(y, ms) {
          tweening = true;
          progress = 0;
          glide(y, ms, function(p) {
            progress = p;
          }, function() {
            if (destroyed) return;
            tweening = false;
            if (pending) {
              var d = pending;
              pending = 0;
              step(d);
            }
          });
        }
        function step(direction) {
          var target = targetFor(direction);
          glideTo(target.y, target.ms);
        }
        function onWheel(event) {
          if (destroyed || !inside()) return;
          if (options.blocked && options.blocked()) return;
          event.preventDefault();
          var d = wheelPixels(event);
          if (Math.abs(d) < THRESHOLD) return;
          var direction = d < 0 ? -1 : 1;
          if (tweening) {
            if (progress >= TAIL) pending = direction;
            return;
          }
          step(direction);
        }
        window.addEventListener("wheel", onWheel, { passive: false });
        return {
          // A resize moves the world under a running tween; drop it where it is.
          cancel: function() {
            token += 1;
            tweening = false;
            pending = 0;
          },
          destroy: function() {
            destroyed = true;
            token += 1;
            pending = 0;
            window.removeEventListener("wheel", onWheel);
          },
          glideTo
        };
      }
      module.exports = { createWheelStepper, wheelPixels, glide };
    }
  });

  // lib/dealer-stage/browser.js
  var mapping = require_mapping();
  var beats = require_beats();
  var scrub = require_scrub();
  var track = require_track();
  var frames = require_frames();
  var videoScrub = require_video_scrub();
  var wheelStep = require_wheel_step();
  function frameUrl(base, index) {
    var n = String(index + 1);
    while (n.length < 4) n = "0" + n;
    return base.replace("f0001", "f" + n);
  }
  function startScroll(stage, world, video, canvas, timeline, beatsData, device) {
    var html = document.documentElement;
    var layer = stage.querySelector("[data-stage-track-layer]");
    var scrim = document.querySelector("[data-stage-scrim]");
    var stockPanel = document.querySelector("[data-toee-size-stock]");
    var submitButton = document.querySelector("[data-toee-search-submit]");
    var dots = stage.querySelectorAll("[data-stage-dot]");
    var topButton = document.querySelector('[data-beat="k5-top"]');
    var closeButton = null;
    var observer = null;
    var modal = false;
    var renderer = null;
    var copy = null;
    var curve = null;
    var stepper = null;
    var worldTop = 0;
    var lastY = -1;
    var lastMove = 0;
    var lastWidth = window.innerWidth;
    var raf = 0;
    var resizeHandle = 0;
    var moves = [];
    var hiddenParent = null;
    function size() {
      return { w: stage.clientWidth, h: stage.clientHeight };
    }
    function measure() {
      var vh = stage.clientHeight || window.innerHeight;
      curve = scrub.curve(timeline, vh);
      world.style.height = curve.length + vh + "px";
      worldTop = world.getBoundingClientRect().top + window.scrollY;
      if (copy) copy.relayout();
      if (renderer && renderer.resize) renderer.resize();
      lastY = -1;
      lastWidth = window.innerWidth;
    }
    function nearestDot(offset) {
      if (!dots.length) return;
      var targets = scrub.holdTargets(curve);
      var nearest = 0;
      for (var i = 1; i < targets.length; i += 1) {
        if (Math.abs(targets[i] - offset) < Math.abs(targets[nearest] - offset)) nearest = i;
      }
      for (var j = 0; j < dots.length; j += 1) {
        if (j === nearest) dots[j].setAttribute("aria-current", "true");
        else dots[j].removeAttribute("aria-current");
      }
    }
    function frame(now) {
      raf = 0;
      var y = window.scrollY;
      var offset = y - worldTop;
      var inside = offset > -1 && offset < curve.length + window.innerHeight * 0.5;
      if (y !== lastY) {
        lastY = y;
        lastMove = now;
        var t = scrub.timeAt(curve, offset);
        renderer.seek(t);
        if (copy) copy.sync(t);
        nearestDot(offset);
      }
      if (inside && now - lastMove < 500) html.setAttribute("data-stage-moving", "");
      else html.removeAttribute("data-stage-moving");
      var vh = stage.clientHeight || window.innerHeight;
      if (offset < -vh || offset > curve.length + vh) return;
      raf = window.requestAnimationFrame(frame);
    }
    function onScroll() {
      if (!raf) raf = window.requestAnimationFrame(frame);
    }
    function onResize() {
      if (resizeHandle) return;
      resizeHandle = window.requestAnimationFrame(function() {
        resizeHandle = 0;
        if (stepper) stepper.cancel();
        if (mapping.chooseSource(window.innerWidth) !== device) {
          teardown();
          html.setAttribute("data-dealer-stage-mode", "stills");
          return;
        }
        if (window.innerWidth !== lastWidth) {
          measure();
          return;
        }
        if (copy) copy.relayout();
        if (renderer && renderer.resize) renderer.resize();
        worldTop = world.getBoundingClientRect().top + window.scrollY;
      });
    }
    function moveIntoStage() {
      Array.prototype.forEach.call(document.querySelectorAll("[data-beat]"), function(el) {
        if (el.closest(".tt-search-holder")) return;
        moves.push({ node: el, parent: el.parentNode, next: el.nextSibling });
        layer.appendChild(el);
      });
      var holder = document.querySelector(".tt-search-holder");
      if (holder) {
        var holderParent = holder.parentNode;
        var holderNext = holder.nextSibling;
        layer.appendChild(holder);
        moves.push({ node: holder, parent: holderParent, next: holderNext });
        if (holderParent && holderParent.children.length === 0) {
          hiddenParent = holderParent;
          hiddenParent.hidden = true;
        }
      }
    }
    function focusables() {
      return Array.prototype.filter.call(stockPanel.querySelectorAll('a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"])'), function(el) {
        return !el.disabled && el.offsetParent !== null;
      });
    }
    function onModalKey(event) {
      if (event.key !== "Tab") return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
    function openModal() {
      modal = true;
      html.setAttribute("data-stage-modal", "");
      stockPanel.setAttribute("role", "dialog");
      stockPanel.setAttribute("aria-modal", "true");
      stockPanel.setAttribute("aria-label", stage.getAttribute("data-stage-modal-label") || "Stock results");
      stockPanel.setAttribute("aria-live", "off");
      stockPanel.addEventListener("keydown", onModalKey);
      if (scrim) scrim.hidden = false;
      if (!closeButton) {
        closeButton = document.createElement("button");
        closeButton.type = "button";
        closeButton.className = "tt-stage-close";
        closeButton.setAttribute("aria-label", stage.getAttribute("data-stage-close-label") || "Close");
        closeButton.textContent = "\xD7";
        closeButton.addEventListener("click", closeModal);
      }
      stockPanel.insertBefore(closeButton, stockPanel.firstChild);
      closeButton.focus();
    }
    function closeModal() {
      if (stockPanel) {
        stockPanel.hidden = true;
        stockPanel.removeAttribute("role");
        stockPanel.removeAttribute("aria-modal");
        stockPanel.setAttribute("aria-live", "polite");
        stockPanel.removeEventListener("keydown", onModalKey);
      }
      modal = false;
      html.removeAttribute("data-stage-modal");
      if (scrim) scrim.hidden = true;
      if (submitButton) submitButton.focus();
    }
    function onPanelMutation() {
      if (!stockPanel.hidden && !modal) openModal();
      else if (stockPanel.hidden && modal) closeModal();
    }
    function onKey(event) {
      if (event.key === "Escape" && modal) {
        event.stopPropagation();
        closeModal();
      }
    }
    function onScrimClick() {
      closeModal();
    }
    function glideTo(y) {
      var ms = Math.max(600, Math.min(4e3, Math.abs(y - window.scrollY) * 2));
      if (device === "desktop") stepper.glideTo(y, ms);
      else wheelStep.glide(y, ms);
    }
    function onDotClick(event) {
      if (modal) return;
      var i = Array.prototype.indexOf.call(dots, event.currentTarget);
      if (i === -1) return;
      glideTo(worldTop + scrub.holdTargets(curve)[i]);
    }
    function onTopClick() {
      if (modal) return;
      if (device === "desktop") stepper.glideTo(0, 4e3);
      else wheelStep.glide(0, 4e3);
    }
    function teardown() {
      if (raf) window.cancelAnimationFrame(raf);
      if (resizeHandle) window.cancelAnimationFrame(resizeHandle);
      if (stepper) stepper.destroy();
      if (renderer) renderer.destroy();
      if (copy) copy.destroy();
      if (observer) observer.disconnect();
      window.removeEventListener("resize", onResize);
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("scroll", onScroll);
      if (scrim) scrim.removeEventListener("click", onScrimClick);
      Array.prototype.forEach.call(dots, function(dot) {
        dot.removeEventListener("click", onDotClick);
      });
      if (topButton) topButton.removeEventListener("click", onTopClick);
      if (closeButton && closeButton.parentNode) closeButton.parentNode.removeChild(closeButton);
      if (modal) closeModal();
      for (var i = moves.length - 1; i >= 0; i -= 1) {
        var m = moves[i];
        m.parent.insertBefore(m.node, m.next);
      }
      moves = [];
      if (hiddenParent) {
        hiddenParent.hidden = false;
        hiddenParent = null;
      }
      html.removeAttribute("data-dealer-stage-mode");
      html.removeAttribute("data-stage-moving");
      html.removeAttribute("data-stage-device");
      world.style.height = "";
    }
    html.setAttribute("data-dealer-stage-mode", "scroll");
    html.setAttribute("data-stage-device", device);
    try {
      if (device === "mobile") {
        var poster = new Image();
        poster.src = stage.getAttribute("data-stage-mobile-poster");
        canvas.hidden = false;
        renderer = frames.createFrameRenderer({
          canvas,
          urlFor: function(i) {
            return frameUrl(stage.getAttribute("data-stage-mobile-frames"), i);
          },
          count: parseInt(stage.getAttribute("data-stage-mobile-frame-count"), 10),
          fps: parseFloat(stage.getAttribute("data-stage-mobile-frame-fps")),
          poster
        });
        poster.onload = function() {
          renderer.resize();
        };
      } else {
        video.src = stage.getAttribute("data-stage-desktop-src");
        video.load();
        renderer = videoScrub.createVideoScrubber({ video });
      }
      copy = track.createTrack({ data: beatsData, timeline, device, size });
      measure();
      if (device === "desktop") {
        stepper = wheelStep.createWheelStepper({
          timeline,
          curve: function() {
            return curve;
          },
          worldTop: function() {
            return worldTop;
          },
          blocked: function() {
            return modal;
          }
        });
      }
      if (stockPanel) {
        observer = new MutationObserver(onPanelMutation);
        observer.observe(stockPanel, { attributes: true, attributeFilter: ["hidden"] });
      }
      if (scrim) scrim.addEventListener("click", onScrimClick);
      Array.prototype.forEach.call(dots, function(dot) {
        dot.addEventListener("click", onDotClick);
      });
      if (topButton) topButton.addEventListener("click", onTopClick);
      window.addEventListener("resize", onResize);
      window.addEventListener("keydown", onKey);
      window.addEventListener("scroll", onScroll, { passive: true });
      moveIntoStage();
      measure();
      raf = window.requestAnimationFrame(frame);
    } catch (e) {
      teardown();
      throw e;
    }
  }
  function init() {
    if (!window.innerWidth || !window.innerHeight) {
      window.requestAnimationFrame(init);
      return;
    }
    var stage = document.querySelector("[data-dealer-stage]");
    if (!stage) return;
    var world = stage.closest("[data-dealer-stage-world]");
    var scope = stage.closest("[data-dealer-stage-page]");
    var video = stage.querySelector("[data-stage-video]");
    var canvas = stage.querySelector("[data-stage-canvas]");
    if (!scope || !world || !video || !canvas) return;
    var device = mapping.chooseSource(window.innerWidth);
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches || !!(navigator.connection && navigator.connection.saveData);
    var poster = stage.getAttribute("data-stage-" + device + "-poster");
    if (poster) video.poster = poster;
    if (reduced || typeof Element.prototype.animate !== "function" || !(window.CSS && CSS.supports && CSS.supports("translate", "0 0"))) {
      document.documentElement.setAttribute("data-dealer-stage-mode", "stills");
      return;
    }
    var timelineUrl = stage.getAttribute("data-stage-" + device + "-timeline");
    var beatsUrl = stage.getAttribute("data-stage-beats");
    Promise.all([timelineUrl, beatsUrl].map(function(url) {
      return fetch(url, { credentials: "omit" }).then(function(response) {
        if (!response.ok) throw new Error(url + " " + response.status);
        return response.json();
      });
    })).then(function(loaded) {
      var timeline = loaded[0];
      var beatsData = loaded[1];
      var errors = mapping.validateTimeline(timeline).concat(beats.validate(beatsData, timeline));
      if (errors.length) throw new Error(errors.join("; "));
      startScroll(stage, world, video, canvas, timeline, beatsData, device);
    }).catch(function() {
      document.documentElement.setAttribute("data-dealer-stage-mode", "stills");
    });
  }
  init();
})();
